export const ProductTemplateEnum = Object.freeze({
	DEFAULT: '',
	PRE_BOOKING: 'pre-booking',
	PRE_BOOKING_PNB: 'pre-booking-pnb',
	DELAY_PNB: 'delay-pnb',
});

export const PDPComponents = Object.freeze({
	PRICE_COMPONENT: 'price_component',
	QUANTITY_COMPONENT: 'quantity_component',
	SHIPPING_COMPONENT: 'shipping_component',
	ADD_TO_BAG_COMPONENT: 'add_to_bag_component',
	VARIANTS_COMPONENT: 'variants_component',
	TALK_TO_FASHION_CONSULTANT_COMPONENT: 'talk_to_fashion_consultant_component',
	NOTIFY_ME_COMPONENT: 'notify_me_component',
	BADGE_COMPONENT: 'badge_component',
});

export const ProductTags = Object.freeze({
	REPEAT_SHIPPING: 'repeat_shipping',
	HVC_SET: 'hvc_set',
	HIDE_PRICE: 'hide_price',
	HVC_ACCESS: 'HVC_access',
	HVC_ESCOBAR: 'HVC_Escobar',
});
